module.exports = __webpack_public_path__ + "statics/img/FullChain-2@2x.af48e579.png";